export interface Integration {
  name: (typeof SUPPORTED_INTEGRATIONS)[number]
  enabled: boolean
}

const SUPPORTED_INTEGRATIONS = [
  'Add Image Link',
  'Upload Media',
  'Embed from URL',
  'Upload Media',
  'Unsplash',
  'GIPHY',
  'Loom',
  'Airtable',
  'Figma',
  'Github',
  'G Maps',
  'Jira',
  'Mermaid',
  'Miro',
  'Twitter',
  'Youtube',
  'Vimeo',
  'Google Docs',
  'Google Forms',
  'Google Slides',
  'Google Sheets',
  'Canva',
  'Clickup',
  'Uploads',
] as const

export const AddImageFromLink: Integration = {
  name: 'Add Image Link',
  enabled: true,
}

export const UploadsLibrary: Integration = {
  name: 'Uploads',
  enabled: true,
}

export const UploadMedia: Integration = {
  name: 'Upload Media',
  enabled: true,
}

export const EmbedURL: Integration = {
  name: 'Embed from URL',
  enabled: true,
}

export const UploadEmbedMedia: Integration = {
  name: 'Upload Media',
  enabled: false,
}

export const Unsplash: Integration = {
  name: 'Unsplash',
  enabled: true,
}

export const Giphy: Integration = {
  name: 'GIPHY',
  enabled: true,
}

export const Loom: Integration = {
  name: 'Loom',
  enabled: true,
}

export const Airtable: Integration = {
  name: 'Airtable',
  enabled: true,
}

export const Figma: Integration = {
  name: 'Figma',
  enabled: true,
}

export const Github: Integration = {
  name: 'Github',
  enabled: true,
}

export const GoogleMaps: Integration = {
  name: 'G Maps',
  enabled: true,
}

export const Mermaid: Integration = {
  name: 'Mermaid',
  enabled: true,
}

export const Miro: Integration = {
  name: 'Miro',
  enabled: true,
}

export const Twitter: Integration = {
  name: 'Twitter',
  enabled: true,
}

export const Youtube: Integration = {
  name: 'Youtube',
  enabled: true,
}

export const Vimeo: Integration = {
  name: 'Vimeo',
  enabled: true,
}

export const GoogleDocs: Integration = {
  name: 'Google Docs',
  enabled: true,
}

export const GoogleForms: Integration = {
  name: 'Google Forms',
  enabled: true,
}

export const GoogleSlides: Integration = {
  name: 'Google Slides',
  enabled: true,
}

export const GoogleSheets: Integration = {
  name: 'Google Sheets',
  enabled: true,
}

export const Canva: Integration = {
  name: 'Canva',
  enabled: true,
}

export const Clickup: Integration = {
  name: 'Clickup',
  enabled: true,
}

export const Jira: Integration = {
  name: 'Jira',
  enabled: true,
}

export const EmbedIntegrations = [
  Airtable,
  Canva,
  Clickup,
  Figma,
  Github,
  GoogleDocs,
  GoogleForms,
  GoogleSheets,
  GoogleSlides,
  GoogleMaps,
  Jira,
  Loom,
  Miro,
  Twitter,
  Vimeo,
  Youtube,
]
